import {Client} from '../../../graphql/types'

const KUWAIT_IB_IDS = [10512, 10544, 10543, 10542, 10508]

export const overrideForKuwaitNetwork = (accounts: any[], client: Client) => {
  if (!client?.metadata) return accounts

  let metadata: any
  try {
    metadata =
      typeof client.metadata === 'string' ? JSON.parse(client.metadata) : client.metadata
  } catch (err) {
    console.warn('Failed to parse metadata:', client.metadata)
    return accounts
  }

  const remoteIbId = metadata?.ibFollowerData?.remoteIbId

  if (!KUWAIT_IB_IDS.includes(remoteIbId)) return accounts

  // Kuwait Network: only allow MT5 standard and black trading accounts, hide others and all affiliate accounts.
  return accounts.filter(
    (account) =>
      ['mt5Std', 'black'].includes(account.accountSubtype) &&
      account.category !== 'affiliate',
  )
}

